// extracted by mini-css-extract-plugin
export default {"align-cc":"Table_align-cc__IFk-B","align-lc":"Table_align-lc__w8IlX","align-rc":"Table_align-rc__xEeOL","table":"Table_table__BcZYj"};